import { TextField } from "@mui/material";
import * as React from "react";
import styled from "styled-components";
import BasicButtons from "../../UI/BasicButtons";
import { useCreateK3Mutation } from "../../../store/coefficientsApi/k3Api";

export default function Create({ onClose }) {
  const [addData] = useCreateK3Mutation();
  const [title, setTitle] = React.useState("");
  const [value, setValue] = React.useState("");

  const inputChangeHandler = (event, setValue) => {
    setValue(event.target.value);
  };

  const formSubmitHandler = (event) => {
    event.preventDefault();
    window.confirm("Вы уверены?");
    const newData = {
    title,
    value
    };
    addData(newData);
    onClose();
  };

  return (
    <StyledForm onSubmit={formSubmitHandler}>
      <TitleOfCreation>Коэффициент определямый от сроков предоставления земельного участка (К3)</TitleOfCreation>
      <BlockStyled width="100%" display="flex" justifyContent="flex-start">
        <TextFieldStylded
          id="outlined-basic"
          label="Наименование"
          variant="outlined"
          value={title}
          onChange={(event) => inputChangeHandler(event, setTitle)}
          size="small"
          width="100%"
          mrg="0 15px 0 0"
        />
        
      </BlockStyled>
        <BlockStyled width="100%" display="flex" justifyContent="flex-start" margin="20px 0">
        <TextFieldStylded
          id="outlined-basic"
          label="Значение"
          variant="outlined"
          value={value}
          onChange={(event) => inputChangeHandler(event, setValue)}
          size="small"
          width="40%"
          mrg="0 15px 0 0"
        />
        </BlockStyled>

      <StyledButtonsdBlock>
        <BlockStyled
          display="flex"
          flexDirection="flex-start"
          alignItems="center"
        ></BlockStyled>

        <BlockStyled display="flex" flexDirection="flex-end">
          <BasicButtons onClick={onClose}>Отменить</BasicButtons>
          <BasicButtons type="submit">Сохранить</BasicButtons>
        </BlockStyled>
      </StyledButtonsdBlock>
    </StyledForm>
  );
}

const BlockStyled = styled.div`
  width: ${(props) => props.width};
  display: ${(props) => props.display};
  justify-content: ${(props) => props.justifyContent};
  flex-direction: ${(props) => props.flexDirection};
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
  align-items: ${(props) => props.alignItems};
`;

const TextFieldStylded = styled(TextField)`
  width: ${(props) => props.width};
  margin: ${(props) => props.mrg};
`;

const StyledButtonsdBlock = styled.div`
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
`;
const TitleOfCreation = styled.h3`
  text-align: center;
`;

const StyledForm = styled.form``;
